<div class="history-row">
  <b tabindex="0"> {{ 'submitProposal.selectedText' | translate }} </b>

  @if (historyDetails.otherExamComponents.length && historyDetails.electives.examComponentName) {
    <pa-add-course-list-header
      [title]="historyDetails.electives.examComponentName"
      class="course-list-header__level1"
    />
  }

  @if (historyDetails.electives.individualArrangements.length) {
    <pa-add-course-list-header
      [title]="'submitProposal.coursesIndividualArrangements' | translate"
      tabindex="0"
      [ngClass]="{ 'course-list-header__level2': historyDetails.otherExamComponents.length }"
    />
    @for (course of historyDetails.electives.individualArrangements; track $index) {
      <pa-history-course-item [course]="course" tabindex="0" />
    }
  }

  @if (historyDetails.electives.courses.length) {
    <pa-add-course-list-header
      [title]="'submitProposal.courses' | translate"
      tabindex="0"
      [ngClass]="{ 'course-list-header__level2': historyDetails.otherExamComponents.length }"
    />
    @for (course of historyDetails.electives.courses; track $index) {
      <pa-history-course-item [course]="course" tabindex="0" />
    }
  }

  @if (historyDetails.otherExamComponents.length) {
    @for (examComponent of historyDetails.otherExamComponents; track examComponent.code) {
      @if (examComponent.courses.length) {
        <pa-add-course-list-header [title]="getExamComponentName(examComponent)" class="course-list-header__level1" />

        @for (course of examComponent.courses; track course.id) {
          <pa-history-course-item [course]="course" />
        }
      }
    }
  }
</div>
